import Store, { type RootState } from '@/redux';
import type { TypedUseSelectorHook } from 'react-redux';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useSelector, useDispatch, useStore } from 'react-redux';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch: () => typeof Store['dispatch'] = useDispatch;
export const useAppStore = () => useStore<typeof Store>;
